import { __makeTemplateObject } from "tslib";
import styled from '@emotion/styled';
import { font } from '@metro-ui/tokens/js';
import { CodeInline } from './CodeInline';
export var CodeBlock = styled(CodeInline)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-size: ", ";\n  line-height: ", ";\n\n  display: block;\n  overflow: scroll;\n"], ["\n  font-size: ", ";\n  line-height: ", ";\n\n  display: block;\n  overflow: scroll;\n"])), font.text.small.size, font.text.small['line-height']);
var templateObject_1;
//# sourceMappingURL=CodeBlock.js.map